(function () {
  /* ── Menu drawer ── */
  var drawer = document.getElementById('MenuDrawer');
  document.querySelectorAll('[data-menu-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!drawer) return;
      var open = drawer.hasAttribute('hidden');
      if (open) { drawer.removeAttribute('hidden'); } else { drawer.setAttribute('hidden', ''); }
      document.querySelectorAll('.tbh-burger').forEach(function (b) { b.setAttribute('aria-expanded', open ? 'true' : 'false'); });
    });
  });
  if (drawer) {
    drawer.addEventListener('click', function (e) { if (e.target === drawer) drawer.setAttribute('hidden', ''); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') drawer.setAttribute('hidden', ''); });
  }

  /* ── 3-up cookie slider ── */
  document.querySelectorAll('[data-cookie-slider]').forEach(function (root) {
    var dataEl = root.querySelector('[data-slider-items]');
    
    var items = [];
    if (root.getAttribute('data-match-tiles') === 'true') { document.querySelectorAll('.ctile[data-slide-src]').forEach(function (t) { items.push({ src: t.getAttribute('data-slide-src'), name: t.getAttribute('data-slide-name'), url: t.getAttribute('data-slide-url') }); }); } if (!items.length && dataEl) { try { items = JSON.parse(dataEl.textContent); } catch (e) { items = []; } }
    if (!items.length) return;
    var total = items.length, current = 0, timer;
    var slots = {
      l: root.querySelector('[data-slot="left"]'),
      c: root.querySelector('[data-slot="center"]'),
      r: root.querySelector('[data-slot="right"]')
    };
    var dotsWrap = root.querySelector('[data-dots]');
    items.forEach(function (_, i) {
      var d = document.createElement('button');
      d.type = 'button'; d.className = 'slider-dot'; d.setAttribute('aria-label', 'Show ' + items[i].name);
      d.addEventListener('click', function () { current = i; render(); reset(); });
      dotsWrap.appendChild(d);
    });
    function wrap(n) { return ((n % total) + total) % total; }
    function fill(slot, item) {
      if (!slot) return;
      var img = slot.querySelector('img'), name = slot.querySelector('.sc-name');
      img.src = item.src; img.alt = item.name; name.textContent = item.name; if (item.url) { slot.setAttribute('href', item.url); } else { slot.removeAttribute('href'); }
    }
    function render() {
      fill(slots.l, items[wrap(current - 1)]);
      fill(slots.r, items[wrap(current + 1)]);
      var ci = slots.c.querySelector('img');
      ci.classList.remove('refreshing'); void ci.offsetWidth;
      fill(slots.c, items[current]);
      ci.classList.add('refreshing');
      dotsWrap.querySelectorAll('.slider-dot').forEach(function (d, i) { d.classList.toggle('active', i === current); });
    }
    function reset() { clearInterval(timer); timer = setInterval(function () { current = wrap(current + 1); render(); }, 3400); }
    root.querySelector('[data-prev]').addEventListener('click', function () { current = wrap(current - 1); render(); reset(); });
    root.querySelector('[data-next]').addEventListener('click', function () { current = wrap(current + 1); render(); reset(); });
    render(); reset();
  });

  /* ── Collection filter pills ── */
  document.querySelectorAll('[data-filter-bar]').forEach(function (bar) {
    var grid = document.querySelector(bar.getAttribute('data-filter-bar'));
    var count = bar.querySelector('[data-filter-count]');
    bar.querySelectorAll('[data-filter]').forEach(function (pill) {
      pill.addEventListener('click', function () {
        var tag = pill.getAttribute('data-filter');
        bar.querySelectorAll('[data-filter]').forEach(function (p) { p.classList.toggle('active', p === pill); });
        var shown = 0;
        grid.querySelectorAll('[data-tags]').forEach(function (card) {
          var tags = (card.getAttribute('data-tags') || '').split('|');
          var show = !tag || tags.indexOf(tag) > -1;
          if (show) { card.removeAttribute('hidden'); shown++; } else { card.setAttribute('hidden', ''); }
        });
        if (count) count.textContent = shown + (shown === 1 ? ' Product' : ' Products');
      });
    });
  });

  /* ── Sampler grid mirrors the homepage cookie tiles ── */ document.querySelectorAll('[data-sampler-grid]').forEach(function (grid) { function done() { grid.classList.remove('is-pending'); } if (grid.getAttribute('data-mirror-home') !== 'true') { done(); return; } fetch('/', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) { if (!html) return; var doc = new DOMParser().parseFromString(html, 'text/html'); var self = '/products/' + grid.getAttribute('data-exclude'); var tiles = [].slice.call(doc.querySelectorAll('.ctile[data-slide-src]')).filter(function (t) { return (t.getAttribute('data-slide-url') || '').split('?')[0] !== self; }); if (!tiles.length) return; grid.innerHTML = ''; tiles.forEach(function (t) { var a = document.createElement('a'); a.className = 'sampler-grid__item'; a.href = t.getAttribute('data-slide-url'); var img = document.createElement('img'); img.src = t.getAttribute('data-slide-src'); img.alt = t.getAttribute('data-slide-name'); var s = document.createElement('span'); s.className = 'sampler-grid__label'; s.textContent = t.getAttribute('data-slide-name'); a.appendChild(img); a.appendChild(s); grid.appendChild(a); }); }).catch(function () {}).then(done); }); /* ── Product thumbnails ── */
  document.querySelectorAll('[data-product-media]').forEach(function (media) {
    var main = media.querySelector('[data-main-image]');
    media.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        main.src = t.getAttribute('data-thumb');
        media.querySelectorAll('[data-thumb]').forEach(function (x) { x.classList.toggle('is-active', x === t); });
      });
    });
  });

  /* ── Variant select keeps price in sync ── */
  document.querySelectorAll('[data-variant-select]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var opt = sel.options[sel.selectedIndex];
      var priceEl = document.querySelector('[data-price]');
      var btn = document.querySelector('[data-add-btn]');
      if (priceEl && opt.getAttribute('data-price')) priceEl.textContent = opt.getAttribute('data-price');
      if (btn) {
        var available = opt.getAttribute('data-available') === 'true';
        btn.disabled = !available;
        btn.textContent = available ? btn.getAttribute('data-label') : btn.getAttribute('data-soldout');
      }
    });
  });
})();
